import { encodeObject } from '../classes/Encodeable';
/**
 * When you need to store data for a long period, a VersionBox can be very usefull. It saves the version of the data in it's encoding.
 * During decoding, it reads the version and continues decoding the data using the provided version instead of the version in the context.
 */
export class VersionBox {
    constructor(data) {
        this.data = data;
    }
    encode(context) {
        return {
            data: encodeObject(this.data, context),
            version: context.version
        };
    }
}
export class VersionBoxDecoder {
    constructor(decoder) {
        this.decoder = decoder;
    }
    decode(data) {
        // Set the version of the decoding context of "data"
        const context = data.field("data");
        context.context.version = data.field("version").integer;
        return new VersionBox(context.decode(this.decoder));
    }
}
//# sourceMappingURL=VersionBox.js.map